import { Question, SanityQuestion, SanityQuestionVariant } from "@common";
import { sanityFetch } from "@natklok/util/sanity";
import groq from "groq";
import { useQuery } from "@tanstack/react-query";
import { questionTypes } from "@natklok/sanity/questionTypes";
import { transformSanityQuestion } from "@natklok/sanity/transform/question";
import { captureException } from "@sentry/react";

const query = groq`*[${questionTypes.map((type) => `_type=="${type}Variant"`).join(" || ")}] {
  _type,
  _id,
  questions[]->{
    _id,
    _type,
    renderProps,
    "imageRenderProps": renderProps { image { asset->{ url } } },
    questionBase {
      title,
      slug {
        current
      },
      description,
      fitsAges,
      fitsProfiles,
      badge,
      correctResultTitle,
      correctResultDesc,
      incorrectResultTitle,
      incorrectResultDesc,
      readMore,
      youtubeVideo
    }
  }
}
`;

function getQuestions(): Promise<Question[]> {
  return sanityFetch<SanityQuestionVariant[]>({ query })
    .then((sanityQuestionVariants) => {
      const returnedQuestions: Array<Question> = [];
      sanityQuestionVariants.forEach((sanityQuestionVariant) => {
        sanityQuestionVariant.questions?.forEach((sanityQuestion: SanityQuestion) => {
          returnedQuestions.push({
            ...transformSanityQuestion(sanityQuestion),
            // relatedQuizModules: [],
            variant: {
              en: sanityQuestionVariant._id,
              sv: sanityQuestionVariant._id,
            },
          });
        });
      });
      return returnedQuestions;
    })
    .catch((error) => {
      captureException(error);
      console.error("Error fetching questions", error);
      return [];
    });
}

export function useQuestions() {
  const { isLoading, error, data } = useQuery<Question[]>({
    queryKey: ["questions"],
    queryFn: getQuestions,
  });

  return { isLoading, error, data };
}
